<template>
  <vuex-table :fields="fields" table_store="pbx/sip-accounts/table" class="table--content-middle">
    <template slot="internal_number_id" slot-scope="{ item }">
      {{ item.internal_number ? item.internal_number.number : '' }}
    </template>

    <template slot="caller_id" slot-scope="{ item }">
      {{ item.caller_id ? item.caller.number : '' }}
    </template>

    <template slot="info" slot-scope="{ item }">
      <sip-account-info :item="item" />
    </template>

    <template slot="wrtc" slot-scope="{ item }">
      <icon :type="item.wrtc ? 'md-checkmark' : 'md-close'" size="18" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <table-dropdown>
        <span class="dropdown-item-icon dropdown-item-icon--edit" @click="edit_item(item)">
          {{ $t('shared.component.table.action.edit') }}
        </span>
        <span class="dropdown-item-icon dropdown-item-icon--trash" @click="remove_item(item)">
          {{ $t('shared.component.table.action.delete') }}
        </span>
      </table-dropdown>
    </template>
  </vuex-table>
</template>

<script>
  import SipAccountInfo from '@pbx/components/sip-accounts/_fragments/sip-accout-info';
  import { SipAccountModalService } from '@pbx/modals/SipAccountModalService';
  import { mapActions } from 'vuex';

  export default {
    components: {
      SipAccountInfo
    },

    computed: {
      fields: function() {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            thStyle: {
              width: '20%'
            }
          },

          {
            key: 'internal_number_id',
            label: this.$t('pbx.sip-account.table.field.internal_number_id'),
            sortable: true,
            thStyle: {
              width: '20%'
            }
          },

          {
            key: 'caller_id',
            label: this.$t('pbx.sip-account.table.field.caller_id'),
            sortable: true,
            thStyle: {
              width: '20%'
            }
          },

          {
            key: 'info',
            label: this.$t('shared.component.table.field.info'),
            sortable: false,
            thStyle: {
              maxWidth: '200px',
              minWidth: '200px'
            }
          },

          {
            key: 'wrtc',
            label: this.$t('pbx.sip-account.form.field.wrtc'),
            sortable: false,
            class: 'text-center',
            thStyle: {
              maxWidth: '100px',
              minWidth: '100px'
            }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: {
              maxWidth: '100px',
              minWidth: '100px'
            }
          }
        ];
      }
    },

    methods: {
      ...mapActions('pbx/sip-accounts/table', ['getAsyncData']),

      remove_item: function(item) {
        SipAccountModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      },

      edit_item: function(item) {
        SipAccountModalService.edit(item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>
